import { None, Option } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../../../syntax/index.js";
import { Color } from "../../../color/index.js";
import { LengthPercentage } from "../../../numeric/index.js";
import { Value } from "../../../value.js";
const { either, pair, map, left, right } = Parser;
/**
 * {@link https://drafts.csswg.org/css-images/#color-stop}
 */
export class Stop extends Value {
    static of(color, position = None) {
        return new Stop(color, position);
    }
    _color;
    _position;
    constructor(color, position) {
        super("stop", (Value.hasCalculation(color) ||
            position
                .map(Value.hasCalculation)
                .getOr(false)));
        this._color = color;
        this._position = position;
    }
    get color() {
        return this._color;
    }
    get position() {
        return this._position;
    }
    resolve(resolver) {
        return new Stop(this._color.resolve(), this._position.map(LengthPercentage.resolve(resolver)));
    }
    partiallyResolve(resolver) {
        return new Stop(this._color.resolve(), this._position.map(LengthPercentage.partiallyResolve(resolver)));
    }
    equals(value) {
        return (value instanceof Stop &&
            value._color.equals(this._color) &&
            value._position.equals(this._position));
    }
    hash(hash) {
        hash.writeHashable(this._color).writeHashable(this._position);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            color: this._color.toJSON(),
            position: this._position.map((position) => position.toJSON()).getOr(null),
        };
    }
    toString() {
        return `${this._color}${this._position
            .map((position) => ` ${position}`)
            .getOr("")}`;
    }
}
(function (Stop) {
    function isStop(value) {
        return value instanceof Stop;
    }
    Stop.isStop = isStop;
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-linear-color-stop}
     */
    Stop.parse = either(map(pair(left(Color.parse, Token.parseWhitespace), LengthPercentage.parse), (result) => {
        const [color, position] = result;
        return Stop.of(color, Option.of(position));
    }), map(pair(LengthPercentage.parse, right(Token.parseWhitespace, Color.parse)), (result) => {
        const [position, color] = result;
        return Stop.of(color, Option.of(position));
    }), map(Color.parse, (color) => Stop.of(color)));
})(Stop || (Stop = {}));
//# sourceMappingURL=stop.js.map